import React, { useCallback, useState } from 'react';
import { IKnowladgeGraphInstance } from '../../../../../../interface/interfaces';
import { CellProps, Column } from 'react-table';
import { Combo } from '../../../../../shared/Combo/Combo';
import { ComboSelect } from '../../../../../../constants/constants';
import { Input } from '../../../../../shared/Input/Input';
import { Badge } from '../../../../../shared/Badge/Badge';

// interface IColumns{
//     header: string,
//     accessor: keyof IKnowladgeGraphInstance;
//     Cell?: ({ value }: { value: string | null | number }) => ReactNode;

// }

const MemoizedInput = React.memo(({ value, onChange, placeholder }: any) => <Input hasRef={false} stretch func={onChange} value={value} placeholder={placeholder} />);

MemoizedInput.displayName = 'MemoizedInput';

export const COLUMNS: Column<IKnowladgeGraphInstance>[] = [
    {
        Header: 'Status',
        accessor: 'status',
        width: 40,
        Cell: ({ value }: CellProps<IKnowladgeGraphInstance, string | undefined>) => {
            return (
                <div className="status-cell" style={{ fontSize: '1rem' }}>
                    {/* <IconComponent size={2.5} iconName={`${value && value === "New" ? 'New' : 'Changed'}`}/> */}
                    <Badge label={`${value && value === 'New' ? 'New' : 'Changed'}`} color={`${value && value === 'New' ? 'accent-green' : 'error'}`} />
                </div>
            );
        },
    },

    {
        Header: 'id',
        accessor: 'id',
        width: 80,
    },
    {
        Header: 'Asset name',
        accessor: 'name',
        width: 60,
    },
    {
        Header: 'Attribut name',
        accessor: 'attribute_name',
        width: 300,
        Cell: ({ value }: CellProps<IKnowladgeGraphInstance, string | undefined>) => {
            return <div className="attribute-name-cell">{value}</div>;
        },
    },
    {
        Header: 'Old value',
        accessor: 'old',
        width: 100,
        Cell: ({ value }: CellProps<IKnowladgeGraphInstance, string | number | null | undefined>) => {
            return <div className="old-value-cell">{value}</div>;
        },
    },
    {
        Header: 'New value',
        accessor: 'new',
        width: 100,
        Cell: ({ value }: CellProps<IKnowladgeGraphInstance, string | number | null | undefined>) => {
            return <div className="new-value-cell">{value}</div>;
        },
    },
    {
        Header: 'Priority',
        accessor: 'priority',
        width: 50,
        Cell: ({ row }: CellProps<IKnowladgeGraphInstance, string | undefined>) => {
            const onChange = (str: string) => {
                // console.log('From table: ', str, row)
                row.original.priority = str;
            };

            return (
                <div className="priority-cell">
                    {/* {value} */}
                    <Combo options={ComboSelect.PRIORITY} onChange={onChange} />
                </div>
            );
        },
    },
    {
        Header: 'Overwritten',
        accessor: 'overwritten',
        Cell: ({ row }: CellProps<IKnowladgeGraphInstance, string | undefined>) => {
            const [value, setValue] = useState<string>('');

            const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
                setValue(e.target.value);
                row.original.overwritten = e.target.value;
            };

            return <Input hasRef={false} func={onChange} value={value} placeholder="Change value" />;
        },
    },
    {
        Header: 'Comment',
        accessor: 'comment',
        Cell: ({ row }: CellProps<IKnowladgeGraphInstance, string | undefined>) => {
            const [value, setValue] = useState<string>(row.original.comment || '');

            // useCallback da se funkcija onChange memoizuje, ne bude kreirana pri svakom renderovanju
            const onChange = useCallback(
                (e: React.ChangeEvent<HTMLTextAreaElement>) => {
                    setValue(e.target.value);
                    row.original.comment = e.target.value;
                },
                [row],
            );

            return <MemoizedInput value={value} onChange={onChange} placeholder="Add comment" />;
        },
    },
];
